/** MTP effective role from `GET /v1/teachers/me` → `roleCodes`. */
export const LECKE_ADMIN_ROLE_CODE = 'lecke_admin';
